import React, { Component } from 'react'
import axios from 'axios'
import swal from 'sweetalert'
import { connect } from 'react-redux'
import { Button, FormControl, Row, Col } from 'react-bootstrap'
import { handleErrorFetchingData } from '../../../functions/errorHandling'
import getServerURL from '../../../functions/getServerURL'

import DuplicateMetadataModal from './DuplicateMetadataModal'

class AddMetadataValue extends Component {
  state = {
    newMetadataValue: '',
    newValueAlreadyExists: false,
    valueThatAlreadyExists: null,
    newValueIsExactDuplicate: false,
  }


  listOfMetadataTypes = () => {

    if (!this.props.selectedMetadata) {
      return null
    }

    const values = this.props.selectedMetadata[this.props.valuesFieldName].sort((a, b) => a.option.localeCompare(b.option))

    return (
      <ul>
        {values.map(val => {
          return (
            <Col md={6} key={val.id}>
              <li>
                {val.option}
              </li>
            </Col>
          )
        })}
      </ul>
    )
  }

  checkIfMetadataValueExists = () => {
    if (!this.state.newMetadataValue) {
      return swal({
        title: "Error",
        text: "Please enter a value before saving",
        icon: "error",
        button: "Continue",
      })
    }

    const { valuesFieldName } = this.props

    const exactMatchingValue = this.props.selectedMetadata[valuesFieldName].find(val => {
      return val.option.toLowerCase() === this.state.newMetadataValue.toLowerCase()
    })

    if (exactMatchingValue) {
      return this.setState({
        newValueAlreadyExists: true,
        valueThatAlreadyExists: exactMatchingValue,
        newValueIsExactDuplicate: true,
      })
    }

    const matchingValue = this.props.selectedMetadata[valuesFieldName].find(val => {
      return val.option.toLowerCase().includes(this.state.newMetadataValue.toLowerCase()) ||
      this.state.newMetadataValue.toLowerCase().includes(val.option.toLowerCase())
    })

    if (matchingValue) {
      return this.setState({
        newValueAlreadyExists: true,
        valueThatAlreadyExists: matchingValue,
        newValueIsExactDuplicate: false,
      })
    }

    return this.handleSubmit()
  }


  handleCancelSubmit = () => {
    return this.setState({
      newValueAlreadyExists: false,
      valueThatAlreadyExists: null,
      newValueIsExactDuplicate: false,
      newMetadataValue: '',
    })
  }


  handleSubmit = () => {
    const { newMetadataValue } = this.state
    const { selectedMetadata, valuesFieldName, user, selectedClient } = this.props

    if (newMetadataValue) {

      swal({
        text: "Saving metadata value... Please stand by.",
        icon: require("../../../static/images/spinner.gif"),
        button: false
      })

      axios({
        method: "POST",
        url: `${getServerURL()}${this.props.route}/`,
        headers: {"Authorization": "Bearer " + localStorage.getItem("token")},
        data: {
          created_by: user,
          option: newMetadataValue,
          metadata: selectedMetadata.url,
          client: selectedClient.url,
          proposal_metadata: selectedMetadata.url,
        }
      })
      .then(response => {
        this.props.addMetadataValue(response.data)
        this.props.resetSelectedMetadataAfterSave()
        swal({
          title: "Success",
          text: "The " + this.props.selectedMetadata.name + " has been created",
          icon: "success",
          button: "Continue",
        })
        this.setState({
          newMetadataValue: "",
          selectedMetadata: {
            ...selectedMetadata,
            [valuesFieldName]: [...selectedMetadata[valuesFieldName], response.data],
          },
          newValueAlreadyExists: false,
          valueThatAlreadyExists: null,
          newValueIsExactDuplicate: false,
        })
      })
      .catch(error => {
        const message = `There was an error creating your ${selectedMetadata.name}`
        handleErrorFetchingData(error, message)
      })
    } else {
      swal({
        title: "Error",
        text: "Please enter a value before saving",
        icon: "error",
        button: "Continue",
      })
    }
  }

  render() {
    const { selectedClient, metadata, valuesFieldName, selectedMetadata, selectedModel } = this.props

    const { newValueAlreadyExists, valueThatAlreadyExists, newValueIsExactDuplicate } = this.state

    return (
      <div id="AddMetadataValue">

        {newValueAlreadyExists ?
          <DuplicateMetadataModal
            show={newValueAlreadyExists}
            name={valueThatAlreadyExists ? valueThatAlreadyExists.option : ""}
            isExactDuplicate={newValueIsExactDuplicate}
            typeOrValue={"value"}
            projectOrProposal={selectedModel}
            client={selectedClient}
            handleSubmit={this.handleSubmit}
            handleCancelSubmit={this.handleCancelSubmit}
          />
          :
          null
        }

        {this.props.metadata.length === 0 ?
          <div>There are no existing Metadata.</div>
          :
          <Row>
            <Col md={6}>
              <h5>
                Input the name of the new &nbsp;
                <FormControl
                  style={{display:"inline-block", maxWidth:"50%"}}
                  componentClass="select"
                  onChange={e => this.props.handleSwitchSelectedMetadata(e, 'selectedMetadata')}
                  selected={selectedMetadata}
                >
                  {metadata.map(meta => {
                    return (
                      <option
                        key={meta.id}
                        value={meta.id}
                      >
                        {meta.name}
                      </option>
                    )
                  })}
                </FormControl> &nbsp;below:
              </h5>
            <Col xs={6} sm={6} md={6} lg={6} style={{paddingLeft:"0", width: '90%'}}>
              <FormControl
                type="text"
                value={this.state.newMetadataValue}
                placeholder={`Enter ${selectedMetadata.name}...`}
                onChange={(e) => this.setState({ newMetadataValue: e.target.value })}
              />
              <br/>
              <Button onClick={this.checkIfMetadataValueExists} bsStyle="primary">
                Submit
              </Button>
            </Col>
          </Col>
          <Col md={6}>
            {selectedMetadata && selectedMetadata[valuesFieldName].length > 0 ?
              <span>
                List of {selectedClient.name} {selectedClient.short_code} {selectedMetadata.name} values that already exist
                {this.listOfMetadataTypes()}
              </span>
              :
              <span>
                No {selectedClient.name} {selectedClient.short_code} {selectedMetadata.name} values exist in the database
              </span>
            }
          </Col>
        </Row>
      }
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.manageLogin.user
  }
}

export default connect(mapStateToProps)(AddMetadataValue)



// WEBPACK FOOTER //
// ./src/routes/manager/components/AddMetadataValue.js